var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-6"},[_c('px-card',{attrs:{"title":"Expenses"}},[_c('div',{staticClass:"card-body expense-chart"},[_c('apexchart',{attrs:{"type":"area","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }